module.exports = __webpack_public_path__ + "img/bs_nav_mobil_banner.e839bdf.jpg";